import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fieldPropTypes } from "redux-form"
import PropTypes from "prop-types"
import _ from "lodash"

import { Box, IconButton } from "@material-ui/core"
import MenuItem from "@material-ui/core/MenuItem"
import AddIcon from "@material-ui/icons/Add"
import { makeStyles } from "@material-ui/core/styles"

import SelectInput from "../../../component/forms/SelectInput"
import userProfileSlice from "./userProfileSlice"

const { actions: userProfile } = userProfileSlice

const useStyle = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignContent: "center"
  },
  input: {
    width: "100%"
  },
  action: {
    display: "flex",
    alignContent: "center"
  }
}))

export default function UserProfileSelector(props) {
  const { input, label, editProfile } = props
  const classes = useStyle()
  const dispatch = useDispatch()
  const userProfileList = useSelector((state) => state["admin.userProfile"])

  // fetch all when mounting component
  useEffect(() => {
    dispatch(userProfile.fetchAll())
    return () => {
      dispatch(userProfile.clear())
    }
  }, [dispatch])

  return (
    <Box className={classes.root}>
      <SelectInput
        label={label}
        input={{
          name: "user-profile-selector",
          value: input.value,
          onChange: input.onChange
        }}
        className={classes.input}
      >
        {_.map(userProfileList, (profile, idx) => (
          <MenuItem key={idx} value={profile._id}>
            {profile.label}
          </MenuItem>
        ))}
      </SelectInput>
      <Box className={classes.action}>
        <IconButton aria-label="add-user-profile" onClick={() => editProfile()}>
          <AddIcon color="primary" />
        </IconButton>
      </Box>
    </Box>
  )
}

UserProfileSelector.propTypes = {
  ...fieldPropTypes,
  editProfile: PropTypes.func.isRequired
}
